const sideMenu = [
  {
    id: "events",
    label: "Events",
    href: "/admin/event",
    permissions: [1,3]
  },
  {
    id: "ticket-management",
    label: "Tickets",
    href: "/admin/ticket-management",
    permissions: [3]
  },
  {
    id: "voucher",
    label: "Vouchers",
    href: "/admin/voucher",
    permissions: [1,3]
  },
  {
    id: "userlist",
    label: "Users",
    href: "/admin/users",
    permissions: [3]
  },
];

export default sideMenu;
